import React from "react";

import RandingStyle30 from "../../randing/RandingStyle30";

function Randing511({ urlCode, urlCodeSettingId }) {
  const footerData = {
    line1: "검단뉴욕치과의원 | 대표 : 추성욱 | 사업자등록번호 : 619-28-01281",
    line2: "인천 서구 원당대로 1045, 4층 404호,405호,406호,407호(원당동,금호헤리티지7) TEL. 032-567-8528",
    line3: "COPYRIGHT© GEOMDAN NEWYORK CLINIC ALL RIGHTS RESERVED"
  };

  return (
    <RandingStyle30
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      videoSrc="https://d1k8m48tkgq306.cloudfront.net/images/511/2_new.mp4"
      stepImageBasePath="https://d1k8m48tkgq306.cloudfront.net/images/511"
      companyName="본원"
      privacyCompanyName="검단뉴욕치과의원"
      topImg={`${process.env.REACT_APP_CDN_BASE}/images/511/1.jpg`}
      callIconImg={`${process.env.REACT_APP_CDN_BASE}/images/508/callButton.png`}
      callNumber="0507-1381-8528"
      customFooter={true}
      footerData={footerData}
      footerStyle={{ background: "#F5F0EC" }}
    />
  );
}

export default Randing511;
